import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { observer } from 'mobx-react'
import store from '../store'
import style from '../style.module.less'
import { getObjValue } from '@hlj/hlj-utils'

@observer
export default class extends Component {
  render() {
    const { visible, liveProtocol } = store

    return (
      <Modal
        title={getObjValue(liveProtocol, 'protocolTitle')}
        visible={visible}
        width={640}
        onCancel={store.operateModal}
        footer={[
          <Button key="back" onClick={store.operateModal}>
            关闭
          </Button>
        ]}
      >
        <div
          className={style.agreenment}
          dangerouslySetInnerHTML={{
            __html: getObjValue(liveProtocol, 'protocolContent')
          }}
        />
      </Modal>
    )
  }
}
